
export default {
  props: {
    selector: { type: String, required: false, default: null }
  },
  data: () => ({ show: false }),
  mounted () {
    this._scrollElement = this.selector ? document.querySelector(this.selector) : window
    this._scrollElement.addEventListener('scroll', this.onScroll)
  },
  destroyed () {
    if (this._scrollElement) {
      this._scrollElement.removeEventListener('scroll', this.onScroll)
    }
  },
  methods: {
    onScroll (e) {
      const top = this.selector ? e.target.scrollTop : (window.pageYOffset || document.documentElement.offsetTop || 0)
      this.show = top > 300
    },
    toTop () {
      if (this.selector) {
        // WARNING: smooth animation was having some sideeffect on virtual scroll management
        // leave it off
        // this._scrollElement.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        this._scrollElement.scrollTo({ top: 0, left: 0 })
      } else {
        if (this.$route.hash) this.$router.push({ hash: '' })
        this.$vuetify.goTo(0)
      }
    }
  }
}
